import { render } from "./Return.vue?vue&type=template&id=4537ec0a&scoped=true"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"

import "./Return.vue?vue&type=style&index=0&id=4537ec0a&scoped=true&lang=css"
import "./Return.vue?vue&type=style&index=1&id=4537ec0a&lang=scss"
import "./Return.vue?vue&type=style&index=2&id=4537ec0a&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4537ec0a"]])

export default __exports__